// extracted by mini-css-extract-plugin
export default {"kukariWrapper":"styles_kukariWrapper__H7Ncx","kukariBounce":"styles_kukariBounce__RTPXv","kukari-image":"styles_kukari-image__x7NeX"};